import './ContactSection.css';

export default function ContactSection() {
    return (
        <section className="contact-section" id="contact">
            <div className="contact-container">
                <div className="contact-heading">
                    <p className="contact-badge">Contact</p>

                    <h2 className="contact-title">
                        Parlons de votre projet de rénovation
                        <span> avec Kyra Renov</span>
                    </h2>

                    <p className="contact-subtext">
                        Vous avez un projet de rénovation intérieure ou extérieur, une question ou besoin
                        d’un devis ? Contactez-nous pour échanger sur vos besoins et donner
                        vie à vos idées dans les meilleures conditions.
                    </p>
                </div>

                <div className="contact-grid">
                    <div className="contact-card contact-info-card">
                        <div className="contact-info-top">
                            <span className="contact-label">Téléphone :  </span>
                            <p></p>
                            <a href="tel:+33766138777" className="contact-phone">
                                07 66 13 87 77
                            </a>
                        </div>

                        <div className="contact-details">
                            <div className="contact-detail-item">
                                <div className="contact-detail-icon">✦</div>
                                <div>
                                    <h3>Échange rapide</h3>
                                    <p>
                                        Un premier contact simple pour comprendre votre besoin et
                                        vous orienter vers la bonne solution.
                                    </p>
                                </div>
                            </div>

                            <div className="contact-detail-item">
                                <div className="contact-detail-icon">◆</div>
                                <div>
                                    <h3>Projet sur mesure</h3>
                                    <p>
                                        Chaque demande est étudiée avec attention selon votre
                                        espace, vos attentes et votre budget.
                                    </p>
                                </div>
                            </div>

                            <div className="contact-detail-item">
                                <div className="contact-detail-icon">●</div>
                                <div>
                                    <h3>Zone d’intervention</h3>
                                    <p>
                                        Intervention en Île-de-France pour vos travaux de rénovation
                                        intérieure.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <a href="tel:+33766138777" className="contact-cta">
                            Appeler maintenant
                        </a>
                    </div>

                    <div className="contact-card contact-map-card">
                        <div className="contact-map-header">
                            <span className="contact-label">Localisation</span>
                            <h3>4 Place Tony Garnier, Alfortville</h3>
                        </div>

                        <div className="contact-map-wrapper">
                            <iframe
                                title="Kyra Renov localisation"
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2624.149421712876!2d2.4196721156744457!3d48.802431079282085!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e673c82857c071%3A0xdda83c32ebd4cfbd!2s4%20Pl.%20Tony%20Garnier%2C%2094100%20Alfortville!5e0!3m2!1sfr!2sfr!4v1717621490000!5m2!1sfr!2sfr"
                                width="100%"
                                height="100%"
                                allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                            ></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}